import React, { useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ModalOverlay = styled.div`
  // position absolute for admin, fixed for app
  position: ${props => (props.absolute ? 'absolute' : 'fixed')};

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 518;
`;

const ModalContainer = styled.div`
  border-radius: 5px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  width: ${props => props.width};
`;

export const Modal = ({
  isOpen,
  onClose,
  children,
  width = '998px',
  absolute = false,
}) => {
  const modalRef = useRef();

  const handleOutsideClick = e => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={handleOutsideClick} absolute={absolute}>
      <ModalContainer width={width} ref={modalRef}>
        {children}
      </ModalContainer>
    </ModalOverlay>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  width: PropTypes.string,
  absolute: PropTypes.bool,
};
